module.exports = __webpack_public_path__ + "media/cpsp.88cf36b1.mp4";